//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import myQuery from './components/Query';
import myResult from './components/Result';
import myPagination from './components/Pagination';

export default {
	name: "SearchApp",
	components: {
		myQuery,
		myResult,
		myPagination,
	}
};
